import React from "react";
import { Link } from 'react-router';
import { prefetchRoute } from '../../utils/prefetchRoute';
import KickerEckLogo from "./KickerEckLogo";
import { NAVIGATION_SECTIONS, SECTION_IDS, ROUTES } from "../../constants/routes";

const Navigation = () => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href={`#${SECTION_IDS.PAGE_TOP}`}>
            <KickerEckLogo />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {NAVIGATION_SECTIONS.map(({ id, label }) => (
              <li key={id}>
                {id === SECTION_IDS.GALLERY ? (
                  <Link
                    to={ROUTES.GALLERY}
                    onMouseEnter={() => prefetchRoute('gallery')}
                    className="page-scroll"
                  >
                    {label}
                  </Link>
                ) : (
                  <a href={`#${id}`} className="page-scroll">
                    {label}
                  </a>
                )}
              </li>
            ))}
            <li className="action">
              <Link
                to={ROUTES.CHALLENGER}
                onMouseEnter={() => prefetchRoute('challenger')}
                reloadDocument
              >
                Anmeldung MiniChallenger
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
